import { AbstractConfDataCommand } from "./abstractConfDataCommand";

export class CopyCommand extends AbstractConfDataCommand {
  getDestinationList?: boolean;
  noOfCopies?: number;
  destinationId?: number;
}